export class RmaStatusModel {
  rmaNumber: string;
  poNumber: string;
  customerNumber: string;
  googleCaptcha: string;
}
